import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  CUSTOMER_CARE_EMAIL_MAILTO,
  ORIGINATION_SUPPORT_DISPLAY,
  ORIGINATION_SUPPORT_TEL,
  WEB_BUNDLE_VERSION,
} from '@ld.consumer-portal/constants';
import { footerEnvelopeIcon, footerPhoneIcon, shareMyScreenIcon } from '@ld.consumer-portal/data-uri';

import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ld-login-footer',
  imports: [SvgIconComponent, TranslocoDirective, MatProgressSpinnerModule],
  templateUrl: './login-footer.component.html',
  styleUrl: './login-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'max-sm:w-full max-sm:block',
  },
})
export class LoginFooterComponent {
  isMobile = input<boolean>(false);

  isShareScreenLoading = input<boolean>(false);

  supportBgColor = input<string>('#f4f4f7');

  version = input<string>(WEB_BUNDLE_VERSION);

  readonly shareScreenClick = output<void>();

  protected readonly phoneIconSrc = footerPhoneIcon;
  protected readonly envelopeIconSrc = footerEnvelopeIcon;
  protected readonly shareScreenIconSrc = shareMyScreenIcon;

  protected readonly supportPhoneDisplay = ORIGINATION_SUPPORT_DISPLAY;
  protected readonly supportPhoneTel = ORIGINATION_SUPPORT_TEL;
  protected readonly customerCareEmailMailto = CUSTOMER_CARE_EMAIL_MAILTO;

  protected onShareScreenClick(): void {
    this.shareScreenClick.emit();
  }
}
